export type MediaQueryThreshold = 'xs' | 's' | 'm' | 'l' | 'xl' | 'xxl';

// Use in combination with useMediaQuery
const mediaQueryThresholds: Record<MediaQueryThreshold, number> = {
  xs: 0, // X-Small devices (portrait phones, less than 576px)
  s: 576, // Small devices (landscape phones, 576px and up)
  m: 768, // Medium devices (tablets, 768px and up)
  l: 992, // Large devices (desktops, 992px and up)
  xl: 1200, // X-Large devices (large desktops, 1200px and up)
  xxl: 1400, // XX-Large devices (larger desktops, 1400px and up)
};

export const mediaQuery = {
  thresholds: mediaQueryThresholds,
  atMost: {
    xs: `(max-width: ${mediaQueryThresholds.s - 1}px)`,
    s: `(max-width: ${mediaQueryThresholds.m - 1}px)`,
    m: `(max-width: ${mediaQueryThresholds.l - 1}px)`,
    l: `(max-width: ${mediaQueryThresholds.xl - 1}px)`,
    xl: `(max-width: ${mediaQueryThresholds.xxl - 1}px)`,
    // xxl: `(min-width: 0)`, // N/A
  },
  atLeast: {
    // xs: `(min-width: ${mediaQueryThresholds.xs})`, // N/A
    s: `(min-width: ${mediaQueryThresholds.s}px)`,
    m: `(min-width: ${mediaQueryThresholds.m}px)`,
    l: `(min-width: ${mediaQueryThresholds.l}px)`,
    xl: `(min-width: ${mediaQueryThresholds.xl}px)`,
    xxl: `(min-width: ${mediaQueryThresholds.xxl}px)`,
  },
};
